<template>
  <div class="club-list-container">
    <!-- 页面主体 (默认显示) -->
    <div class="container">
      <!-- 顶部区域：标题 -->
      <div class="header">
        <div class="title">球杆权益</div>
      </div>
      <div class="desc">
        <span >置换估价、换补差价格仅供参考，具体价格以实物鉴定为准</span>
      </div>

      <!-- 球杆列表 -->
      <div v-if="benefitsList.length > 0" class="card-list">
        <el-row :gutter="20">
          <!-- 循环渲染每一个球杆卡片 -->
          <el-col
              v-for="club in benefitsList"
              :key="club.id"
              :span="8"
              :xs="24"
              :sm="12"
              class="card-container"
          >
            <el-card shadow="hover" class="club-card">
              <!-- 卡片主体内容 -->
              <div class="card-body">
                <div class="info-item">
                  <span class="label">名称:</span>
                  <span class="value">{{ club.name }}</span>
                </div>
                <div class="info-item">
                  <span class="label">权益:</span>
                  <span class="value" style="color: #ea9538">{{ club.equityIntro }}</span>
                </div>
                <div class="info-item">
                  <span class="label">置换估价:</span>
                  <span class="value">{{ club.replacementValuation }}</span>
                </div>
                <div class="info-item">
                  <span class="label">换补差:</span>
                  <span class="value">{{ club.supplement }}</span>
                </div>
                <div class="info-item">
<!--                  <span class="label">跨色换补差</span>-->
                  <el-button v-if="state != '1' && state != '2'" type="primary" @click="refurbish(club.id)">翻新</el-button>
                  <el-button v-if="state != '1' && state != '2'" type="primary" @click="replacement(club.id)">置换</el-button>
                </div>
                <!-- 跨色换补差表格 -->
                <div v-if="club.children && club.children.length > 0" class="cross-color-table-container">
                  <el-table
                      :data="club.children"
                      border
                      style="width: 100%"
                      show-header
                  >
                    <el-table-column align="center" label="跨色换补差">
                      <el-table-column prop="name" label="名称" align="left" />
                      <el-table-column prop="supplement" label="换补差(元)" align="left" />
                    </el-table-column>
                  </el-table>
                </div>

              </div>
            </el-card>
          </el-col>
        </el-row>
      </div>

      <!-- 空数据提示 -->
      <div v-else class="empty-state">
        <el-empty description="暂无球杆权益信息"></el-empty>
      </div>

      <div class="btn-group-back">
        <el-button type="default" @click="goHome">返回</el-button>
      </div>

      <!-- 页脚 -->
      <el-footer class="footer">
        <p>JING-DIAN BILLIARD CLUB AFTER SALES</p>
      </el-footer>
    </div>
    <!-- 调用提示语弹框组件 -->
    <MessageDialog
        v-if="showDialog"
        :title="dialogTitle"
        :content="messageContent"
        :confirmText="confirmText"
        :showCancel="showCancel"
        @confirm="handleDialogConfirm"
        @cancel="handleCancel"
        @close="showDialog = false"
        closeOnMask
    />
  </div>
</template>

<script>
import {benefitsByNumber} from "@/api/sales";
import MessageDialog from "@/views/business/utils/messageDialog.vue";

export default {
  name: "ClubList",
  components: {MessageDialog},
  data() {
    return {
      // 球杆权益列表数据
      benefitsList: [],
      // 提示弹框组件
      showDialog: false,
      dialogTitle: '提示',
      messageContent: '',
      confirmText: '',
      showCancel: false,

      propNumber: '', //我的球杆列表点击事件传递的参数
      state: '',
    };
  },
  watch: {
    // 监听路由参数变化，重新获取权益信息
    "$route.query": {
      immediate: true, // 初始化时立即执行
      handler(newVal) {
        const { number, state } = newVal;
        if (number) {
          this.propNumber = number;
          const parts = number.split('_');
          this.fetchClubList(parts[0]);
        } else {
          this.$message.warning("球杆序列号不能为空");
        }
        if (state) {
          this.state = state;
        }
      },
    },
  },
  methods: {
    //翻新点击事件
    refurbish(benefitsId){
      this.$router.push({
        path: '/benefits_register',
        query: {
          number: this.propNumber+"_"+benefitsId,
          type: '2'
        }
      })
    },
    //置换点击事件
    replacement(benefitsId){
      this.$router.push({
        path: '/benefits_register',
        query: {
          number: this.propNumber+"_"+benefitsId,
          type: '1',
        }
      })
    },
    //询问框确认事件
    handleDialogConfirm(){
      this.showDialog = false;
      this.$router.replace('/my_club');
    },
    //取消事件
    handleCancel(){
      this.showDialog = false;
    },
    // 返回首页
    goHome() {
      // 实际项目可替换为Vue Router跳转：this.$router.push('/')
      this.$router.replace('/my_club');
    },

    async fetchClubList(number) {
      try {
        const response = await benefitsByNumber(number);
        if(response.code == 200) {
          if(response.data.length > 0){
            this.benefitsList = response.data;
          }else{
            //提示信息提示弹框组件是否显示
            this.showDialog = true;
            //显示取消按钮
            this.showCancel = false;
            //确认按钮文案
            this.confirmText = "我知道了";
            //提示信息内容
            this.messageContent = "这款球杆暂未开放福利活动，敬请期待后续更新!";
          }
        }else{
          //提示信息提示弹框组件是否显示
          this.showDialog = true;
          //显示取消按钮
          this.showCancel = false;
          //确认按钮文案
          this.confirmText = "我知道了";
          //提示信息内容
          this.messageContent = response.returnMsg;
        }
      } catch (error) {
        console.error("获取球杆权益失败:", error);
      }
    }
  },
};
</script>

<style lang="scss" scoped>
// 页面整体容器
.club-list-container {
  width: 100%;
  background-color: #f9f9f9;
  min-height: 100vh;

  .container {
    width: 100%;
    height: 100%;
    margin: 0;
    padding: 0;
    box-sizing: border-box;
    max-height: 70vh;
    height: 70vh;

    // 顶部区域
    .header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 0 15px;
      background: #f6c27a;
    }

    // 顶部标题
    .title {
      text-align: center;
      flex-grow: 1;
      line-height: 60px;
      font-size: 16px;
      color: #161616;
      letter-spacing: 1px;
      font-weight: bold;
      margin: 0;
    }
    .desc{
      font-size: 12px;
      padding: 10px 10px 0 10px;
      color: #e53935
    }

    // 卡片列表容器
    .card-list {
      width: 100%;
      margin: 0;
      padding: 20px;
    }

    // 每个卡片的容器
    .card-container {
      margin-bottom: 20px;
    }

    // 卡片样式
    .club-card {
      height: 100%;
      display: flex;
      flex-direction: column;
      border-radius: 10px;
      cursor: pointer;
    }

    // 卡片主体
    .card-body {
      flex-grow: 1;
      padding: 20px;
      display: flex;
      flex-direction: column;
      justify-content: center;
    }

    // 信息项样式
    .info-item {
      display: flex;
      align-items: center;
      margin-bottom: 12px;
      font-size: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      .label {
        font-weight: bold;
        color: #555;
        width: 180px; // <-- 使用固定宽度
        text-align-last: justify; // <-- 核心：实现两端对齐
      }


      .value {
        color: #333;
        word-break: break-all;
        padding-left: 20px; // 增加一点与label的间距
      }
    }

    // 跨色换补差表格容器
    .cross-color-table-container {
      margin-top: 15px; // 与上方信息项保持间距
      ::v-deep .el-table__row{
        height: 20px !important;
      }
    }

    // 空状态提示
    .empty-state {
      display: flex;
      justify-content: center;
      align-items: center;
      height: 400px;
      background-color: #fff;
      border-radius: 8px;
      margin: 20px;
    }
    .btn-group-back {
      display: flex;
      justify-content: center;
      gap: 15px;
      margin: 20px 0;
    }

    // 页脚
    .footer {
      height: 50px;
      background: #2c2c2c;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 20px;
      box-sizing: border-box;

      p {
        color: #ea9538;
        font-size: 10px;
        font-weight: bold;
        letter-spacing: 1px;
        margin: 0;
      }
    }
  }

  // ===================== 移动端适配（<768px） =====================
  @media screen and (max-width: 767px) {
    .container {
      .header {
        padding: 0 10px;
      }
      .title {
        font-size: 16px;
        line-height: 60px;
      }
      .desc {
        font-size: 12px;
        padding: 10px 10px 0 10px;
      }
      .card-list {
        padding: 10px;
      }
      .club-card {
        border-radius: 10px;
      }
      .info-item {
        font-size: 14px;
        .label {
          width: 80px;
          font-weight: 500;
        }
        .value {
          padding-left: 10px;
          width: 300px;
        }
      }
      .cross-color-table-container {
        ::v-deep .el-table__row{
          height: 20px !important;
          font-size: 14px;
        }
        ::v-deep .el-table__cell{
          height: 20px !important;
          font-size: 14px;
        }
        ::v-deep .el-table__cell .cell{
          color: #333;
          height: 20px;
          font-size: 14px;
          line-height: 20px;
        }
        ::v-deep .el-table td.el-table__cell div{
          line-height: 20px !important;
        }
      }
      .empty-state {
        margin: 10px;
        height: 300px;
      }
      .el-button--default{
        font-size: 20px;
        color: #0f0f0f;
        background: #dcdcdc;
        border: none;
        width: 80%;
        border-radius: 3px;
      }
      .el-button--primary{
        font-size: 20px;
        color: #0f0f0f;
        background: #f6c27a;
        border: none;
        width: 50%;
        border-radius: 3px;
      }
      .btn-group-back {
        display: flex;
        justify-content: center;
        gap: 15px;
        height: 40px;
        line-height: 40px;
        margin: 20px 0 20px 0;
      }
      .footer {
        height: 50px;
        margin-top: 15px;
        p {
          font-size: 9px;
          padding: 0 10px;
          text-align: center;
        }
      }
    }
  }

  // ===================== 平板和PC端适配（≥768px） =====================
  @media screen and (min-width: 768px) {
    .container {
      .card-list-wrapper {
        max-width: 700px; // 平板和PC端可以适当放宽
      }
      .info-item {
        font-size: 16px;
        .label {
          width: 120px;
        }
        .value {
          padding-left: 20px;
        }
      }
      .empty-state {
        max-width: 700px;
        margin: 20px auto;
      }
      .footer {
        height: 55px;
        margin-top: 25px;
        p {
          font-size: 11px;
        }
      }
    }
  }
}
</style>